module.exports = "<toaster-container></toaster-container>\n<spinner [backgroundColor]=\"'#ff0000'\"></spinner>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main